export default __webpack_public_path__ + "static/media/inst3.81e725c0.jpg";